<template>
	<div>
    <div class="card notification notification-inbox">
			<div class="col-left">

			</div>
			<div class="col-main scroll-area">
				<vuetable ref="vuetable"
					:fields="columns"
					:api-mode="false"
					:data="data"
					:row-class="onRowClass"
					@vuetable:row-clicked="rowClickHandler"
					class="notification-inbox-table table-hover"
					noDataTemplate="Ничего не найдено">
					<template slot="status" slot-scope="props">
						<span v-if="props.rowData.status < 2 "><i class="fa fa-circle text-primary"></i></span>
					</template>
					<template slot="img" slot-scope="props">
						<user-photo
							:id="props.rowData.user_id"
							:link="false"
						></user-photo>
					</template>

					<template slot="author" slot-scope="props">
						<span>{{ getUsername(props.rowData.user_id) }}</span>
					</template>

					<template slot="text" slot-scope="props">
						<span class="subject" v-if="props.rowData.status < 2 && props.rowData.title !== ''"><strong>{{ props.rowData.title }}</strong> </span>
						<span class="subject" v-if="props.rowData.status === 2 && props.rowData.title !== ''">{{ props.rowData.title }} </span>
						<span class="text line-clamp line-clamp-1">{{ htmlEscape(props.rowData.text) }}</span>
					</template>

					<template slot="created_at" slot-scope="props">
						<span>{{ dateFormatter(props.rowData.created_at) }}</span>
					</template>
				</vuetable>
			</div>
    </div>
		<div class="infinite-scroll-preloader" v-if="infinity"></div>
	</div>
</template>
<script>
import moment from 'moment'
import UserPhoto from '@/components/user/user-photo'
import notificationHTTP from '@/api/modules/notification/notification'
export default {
	components: {
		UserPhoto
	},
	data () {
		return {
			loading: true,
			infinity: false,
			data: [],
			columns: [
				{
					name: '__slot:status',
					dataClass: 'col-status'
				}, {
					name: '__slot:img',
					dataClass: 'col-profile-photo'
				}, {
					name: '__slot:author',
					dataClass: 'col-author'
				}, {
					name: '__slot:text',
					dataClass: 'col-text'
				}, {
					name: '__slot:created_at',
					dataClass: 'col-datetime'
				}
			],
			pagination: {
				curr: null,
				count: null,
				next: null
			},
			scrollInBottom: false
		}
	},
	created () {
		this.getNotifications()
	},
	mounted () {
		this.initInfinityScroll()
	},
	methods: {
		getNotifications (params = {}) {
			if (this.pagination.next !== null) params.page = this.pagination.next
			notificationHTTP.findAll(params).then((response) => {
				let headers = response.headers
				let notifications = response.body
				notifications.forEach((notification, key) => {
					this.data.push(notification)
				})
				this.pagination.curr = parseInt(headers.get('X-Pagination-Current-Page'))
				this.pagination.count = parseInt(headers.get('X-Pagination-Page-Count'))
				this.scrollInBottom = false
				this.loading = false
			})
		},
		onRowClass (dataItem, index) {
			return dataItem.status < 2 ? 'unread' : ''
		},
		htmlEscape (str) {
			return str.split('<')[0].replace(/(<([^>]+)>)/ig, '')
		},
		dateFormatter (date) {
			// date = moment(date).format('YYYY-MM-DD')
			moment.locale('ru')
			// если сегодня
			let currYear = moment().format('YYYY')
			if (date === moment().format('YYYY-MM-DD')) return moment(date).format('LT')
			// если текущий год/не текущий год
			if (currYear === moment().format('YYYY')) {
				return moment(date).format('D MMMM')
			} else {
				return moment(date).format('D MMMM, YYYY')
			}
		},
		getUsername (id) {
			if (Object.keys(this.$store.state.userModule.users).length === 0) return ''
			const user = this.$store.state.userModule.users[id]
			return user.first_name + ' ' + user.last_name
		},
		rowClickHandler (row, event) {
			this.$router.push({path: '/notifications/' + row.id})
		},
		initInfinityScroll () {
			const self = this
			window.addEventListener('scroll', function (event) {
				if (self.scrollInBottom === true) return false
				let scroll = document.querySelector('.main-scroll-area')
				if ((scroll.scrollHeight - scroll.scrollTop) >= scroll.clientHeight) {
					self.scrollInBottom = true
					if (self.pagination.curr < self.pagination.count) {
						self.pagination.next = self.pagination.curr + 1
						self.getNotifications()
						self.infinity = true
					} else {
						self.infinity = false
					}
				}
			})
		}
	},
	watch: {
		'$route' (to, from) {
			console.log(to)
		}
	}
}
</script>>
<style lang="scss">
.notification-inbox {
	margin-bottom: 0 !important;
	border-top: none !important;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
}
.notification-inbox-table {
	padding: 0;
	margin: 0;
	thead { display: none !important }
	tr {
		cursor: pointer;
		&.unread {
			font-weight: bold;
		}
	}
	td {
		vertical-align: middle !important;
	}
	.col-status {
		width: 1%;
		min-width: 36px;
    white-space: nowrap;
	}
	.col-profile-photo {
		width:1%;
    white-space:nowrap;
		.profile-photo {
			display: block;
			width: 40px;
			height: 40px;
			margin: 0 !important;
			.profile-photo-default {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 100% !important;
				height: 100%;
				color: #fff;
				text-transform: uppercase;
				font-size: 1.3em;
			}
			&:hover {
				text-decoration: none !important;
			}
		}
	}
	.col-author, .col-datetime {
		width: 1%;
    white-space: nowrap;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/notification/index.vue